export default {
    tempContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: "1rem",
        width: '100%',
    },
    tempItem: {
        padding: "1rem",
        borderBottom: "1px solid #777",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap:"1rem",
    }
}